/* MedBound — forza "Ausverkauft" + disabilita l'aggiunta al carrello per le
   varianti esaurite (availableForSale=false). Il tema custom non lo fa da solo.
   Legge la disponibilità da /products/<handle>.js e abbina al RADIO selezionato
   tramite il valore opzione (= titolo variante). Ignora i form cross-sell perché
   solo i valori di QUESTO prodotto sono nella mappa. Solo pagine prodotto. */
(function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var SOLD = (window.FoxTheme && FoxTheme.variantStrings && FoxTheme.variantStrings.soldOut) || "Ausverkauft";
  var ADD = (window.FoxTheme && FoxTheme.variantStrings && FoxTheme.variantStrings.addToCart) || "In den Warenkorb";
  var avail = null; // { variantTitle: boolean }

  function btn() { return document.querySelector(".product-form__submit, button[name='add']"); }
  function selectedValue() {
    var rs = document.querySelectorAll("input[type='radio']:checked");
    for (var i = 0; i < rs.length; i++) {
      var v = (rs[i].value || "").trim();
      if (avail && Object.prototype.hasOwnProperty.call(avail, v)) return v;
    }
    return null;
  }
  function apply() {
    if (!avail) return;
    var b = btn(); if (!b) return;
    var v = selectedValue(); if (v == null) return;
    if (avail[v] === false) {
      if (!b.disabled || b.getAttribute("data-mb-oos") !== "1") {
        b.disabled = true; b.setAttribute("aria-disabled", "true"); b.setAttribute("data-mb-oos", "1");
        b.style.opacity = "0.55"; b.style.cursor = "not-allowed";
        var sp = b.querySelector("span"); if (sp) sp.textContent = SOLD; else b.textContent = SOLD;
      }
    } else if (b.getAttribute("data-mb-oos") === "1") {
      b.disabled = false; b.removeAttribute("aria-disabled"); b.removeAttribute("data-mb-oos");
      b.style.opacity = ""; b.style.cursor = "";
      var sp2 = b.querySelector("span"); if (sp2) sp2.textContent = ADD;
    }
  }
  fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      avail = {};
      (p.variants || []).forEach(function (v) { avail[(v.title || "").trim()] = v.available; });
      apply();
      var n = 0, iv = setInterval(function () { apply(); if (++n > 15) clearInterval(iv); }, 350);
      document.addEventListener("change", function (e) { if (e.target && e.target.type === "radio") setTimeout(apply, 60); }, true);
      document.addEventListener("click", function (e) { if (e.target && e.target.closest && e.target.closest(".product-form__input--button, variant-selects")) setTimeout(apply, 160); }, true);
      var b0 = btn();
      if (b0 && b0.parentNode && window.MutationObserver) {
        new MutationObserver(function () { apply(); })
          .observe(b0.parentNode, { childList: true, subtree: true, attributes: true, attributeFilter: ["disabled", "class"] });
      }
    })
    .catch(function () {});
})();
